
import router from '../../router';
import Vue from 'vue';
import {getWebsites, getPayments, getWebsiteAddresses} from "../../api/websites";
import Cookies from 'js-cookie';
import {getToken} from "../../utilis/auth";

const state = {
    websites:null,
    activeWebsite:null,
    selectWebsite: false
};

const actions = {
    getWebsites: ({commit, state, dispatch}) => {
        return new Promise((resolve, reject) => {
            getWebsites({per_page: 10000}).then(response => {
                var my_id = Cookies.get('active_website');
                if(my_id){
                    var finded = response.data.find(x => x.id == my_id);
                }
                commit('SET_WEBSITES', response.data);
                if(response.data.length > 0){
                    if(finded){
                        dispatch('setActive', finded);
                    }else{
                        dispatch('setActive', response.data[0]);
                        state.selectWebsite = true;
                    }
                }
                dispatch('setSubdomainCookies');
                resolve(response);
            }).catch(e => {
                reject();
            })
        })
    },
    getPayments({commit, state}, website_id){
        return new Promise((resolve, reject) => {
            getPayments(website_id, {relations: ['payments'], getTrackingData: 1}).then(response => {
                commit('SET_PAYMENTS', response);
                resolve(response);
            }).catch(e => {
                commit('app/ADD_MESSAGE', {text:'Nie udało się pobrać płatności', type: 'error'}, {root: true});
            })
        })
    },

    setActive: ({commit, state}, website) => {
        Vue.set(state, 'activeWebsite', website);
        if(website){
            Cookies.set('active_website', website.id);
        }
        state.selectWebsite = false;
    },
    setSubdomainCookies: ({commit, state}) => {
        state.websites.forEach(item => {
            Cookies.set('Admin-Token', getToken(), {domain: item.link});
        })
    },

    updateActiveWebsite: ({commit, state}) => {
    }
}
const mutations = {
    UPDATE_WEBSITE: (state, value) =>{
        state.activeWebsite.name = value.name;
        state.activeWebsite.url = value.url;
    },
    SET_WEBSITES: (state, value) => {
        Vue.set(state, 'websites', value);
        Vue.prototype.$eventBus.$emit('refreshSidebar');
    },
    SET_PAYMENTS: (state, value) => {
        var index = state.websites.findIndex(x => x.id == value.id)
        if(index != -1){
            state.websites[index].payments = value.payments;
        }
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
